import { render, staticRenderFns } from "./BaseStatus.vue?vue&type=template&id=5d8636dd&scoped=true&"
import script from "./BaseStatus.vue?vue&type=script&lang=ts&"
export * from "./BaseStatus.vue?vue&type=script&lang=ts&"
import style0 from "./BaseStatus.vue?vue&type=style&index=0&id=5d8636dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8636dd",
  null
  
)

export default component.exports